import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { linkFor, localizedPath, pageLanguage, urlLanguage } from '../content/publicLanguages';
import { useTranslation } from 'react-i18next';
import { blogPosts } from '../content/blogPosts';
import { getLocalizedBlogPosts } from '../content/blogTranslations';
import Seo from './Seo';

const formatDate = (date, language) =>
  new Intl.DateTimeFormat(language || 'en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(new Date(date));

const BlogIndex = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const language = pageLanguage(pathname, i18n);
  const localizedBlogPosts = getLocalizedBlogPosts(blogPosts, language);
  const sortedBlogPosts = localizedBlogPosts
    .filter((post) => post.status !== 'draft')
    .sort(
    (firstPost, secondPost) => new Date(secondPost.publishedAt) - new Date(firstPost.publishedAt)
  );

  return (
    <div className="blog-index-page">
      <Seo
        title={t('public.blog.seo_title')}
        description={t('public.blog.seo_description')}
        canonicalPath={localizedPath('/blog', urlLanguage(pathname))}
      />

      <section className="blog-hero">
        <h1>{t('public.blog.index_title')}</h1>
      </section>

      <section className="blog-grid">
        {sortedBlogPosts.map((post) => (
          <article className="blog-card" key={post.slug}>
            <span className="journal-category">{post.category}</span>
            <h2>
              <Link to={linkFor(`/blog/${post.slug}`, language)}>{post.title}</Link>
            </h2>
            <p>{post.excerpt}</p>
            <div className="journal-meta">
              <span>{formatDate(post.publishedAt, language)}</span>
              <span>{post.readTime}</span>
            </div>
            <Link to={linkFor(`/blog/${post.slug}`, language)} className="blog-card-link">
              {t('public.blog.read_article')} →
            </Link>
          </article>
        ))}
      </section>
    </div>
  );
};

export default BlogIndex;
